<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">字典类型：</span>
        </div>
        <el-select v-model="formData.dictType"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   placeholder="请选择字典类型">
          <el-option v-for="item in categoryList" :key="item.name"
                     :label="item.name" :value="item.name">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">代码：</span>
        </div>
        <el-input v-model="formData.value" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">描述：</span>
        </div>
        <el-input v-model="formData.desc" size="small" style="width: 280px" />
      </div>
    </form>
      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { getObjectURL } from "../../../utils/toBase64";
import { bus } from "../../../utils/bus";
import { api } from "../../api/Group";
import { nError, nSuccess } from "../../../utils/notice";
import { errorHandler } from "../../../utils/errorHandler";
export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "basic-information-add",
  data() {
    return {
      breadcrumb: [
        {
          value: "数据对接",
          name: "customer-master-data"
        },
        {
          value: "基础信息"
        }
      ],
      mainTitle: "添加信息",
      subheading: "",
      formData: {},
      categoryList: [
        { name: "主体住户" },
        { name: "国家" },
        { name: "会计科目" },
        { name: "支付条件" },
        { name: "支付方式" },
        { name: "账户类型" },
        { name: "凭证类型" },
        { name: "费用类型" },
        { name: "现金流项目" }
      ]
    };
  },
  methods: {
    confirm() {
      if (!this.formData.dictType) {
        nError("请选择字典类型");
        return false;
      }
      if (!this.formData.value) {
        nError("请输入代码");
        return false;
      }
      if (!this.formData.desc) {
        nError("请输入描述");
        return false;
      }
      this.$axios
        .post(api.addDaliDictItem, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("添加成功");
            this.$router.push({
              name: "basic-information"
            });
          }
        })
        .catch(errorHandler("添加失败"));
    },
    cancel() {
      this.$router.push({
        name: "basic-information"
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/DataSync/BasicInformation/BasicInformationAdd.vue